export class EmployeeEmailModel {
    mail_sequence: string
    employee_initial: string
    mail_date: string
    subject: string
    message: string
    urgent: boolean
    protected_: boolean
    employee_to: string
    employee_from: string
    notes: string
    // user: string
    private _header: string

    set header(value: string) {
        this._header = value;
    }
    get header(): string {
        let strTmp = '';
        strTmp += `${this.mail_date}  ${this.employee_initial}`;
        if (this.urgent)
            strTmp += ` (URG) `;
        strTmp += `--${this.subject} ** ${this.employee_to}`;
        return strTmp
    }

    constructor(
        mail_sequence: string,
        employee_initial: string,
        mail_date: string,
        subject: string,
        message: string,
        urgent: boolean,
        protected_: boolean,
        employee_to: string,
        employee_from: string,
        notes: string
    ) {
        this.mail_sequence = mail_sequence
        this.employee_initial = employee_initial
        this.mail_date = mail_date
        this.subject = subject
        this.message = message
        this.urgent = urgent
        this.protected_ = protected_
        this.employee_to = employee_to
        this.employee_from = employee_from
        this.notes = notes
    }
}